import React, { useEffect, useState } from "react";
import {
  ArrowsMove,
  BoxArrowDownLeft,
  ExclamationCircle,
} from "react-bootstrap-icons";
import Draggable from "react-draggable";
import KonselorControl from "./KonselorControl";
import useSessionDataPduli from "../../costumeHooks/useSessionDataPduli";
import useValidationDataKonselor from "../../costumeHooks/useValidationDataKonselor";
import {
  COUNSELEE_VAR_SERVER,
  COUNSELOR_VAR_SERVER,
} from "../../constants/SessionKonselingConstants";
import useCoreAgoraPduli from "../../../../general/customHooks/coreAgoraPduli";
import VideoPlayerPduli from "./VideoUser/VideoPlayerPduli";
import { checkVoulumeLevel } from "../../../../general/functions/agoraCustomeFunctions";
import { useDispatch, useSelector } from "react-redux";
import { StartRecordingPduli } from "../../actions/recordingActions";
import useTrigerWaktu from "../../costumeHooks/useTrigetWaktu";

const UidAG = (typeUser) => {
  switch (typeUser) {
    case COUNSELEE_VAR_SERVER:
      return 1;
    case COUNSELOR_VAR_SERVER:
      return 2;
    default:
      return 1;
  }
};

const LIST_USERS = [
  { uid: 1, label: COUNSELEE_VAR_SERVER },
  { uid: 2, label: COUNSELOR_VAR_SERVER },
];

export default function VideoKonselingSession(props) {
  const {
    handleCLoseRoom,
    handleStartRecord,
    handleReGetData,
    forceClose,
    handleForceCloseRoom,
    handleCLoseRoomByServer,
  } = props;
  const { dataValidationUser } = useValidationDataKonselor();
  const [userVISITOR, setUserVISITOR] = useState(null);
  const [isVisit, setIsVisit] = useState(false);
  const [userSELF, setUserSELF] = useState(null);
  const [userCmaMode, setUserCmaMode] = useState(1);
  const {
    usersJoin,
    usersVolume,
    isConnect,
    isSelfTracksReady,
    selfTracks,
    isMuteTrackSelf,
    setJoin,
    setMuteSelfTracks,
    errorInfo,
  } = useCoreAgoraPduli({
    uid: parseInt(UidAG(dataValidationUser.data.typeUser)),
    channelName: dataValidationUser.data.session,
  });
  const { isWillBeEnd } = useTrigerWaktu();

  let recordingIsAvailable = usersJoin.find((x) => x.uid == 3);

  useEffect(() => {
    setJoin(true);
  }, []);

  useEffect(() => {
    if (forceClose) {
      setJoin(false);
      console.log(
        "triger close VC Leave By Server: tahap 3 leave triger on video"
      );
      handleForceCloseRoom();
    }
  }, [forceClose]);
  // PART RECORDING
  useEffect(() => {
    if (isConnect == true) {
      handleStartRecord();
    }
    if (isConnect) {
      setMuteSelfTracks("video", false);
    }
  }, [isConnect]);

  const handleClick = (event) => {
    console.log(event.detail);
    switch (event.detail) {
      case 1: {
        console.log("single click");
        break;
      }
      case 2: {
        // console.log("double click");
        setUserCmaMode(userCmaMode == 1 ? 2 : 1);
        break;
      }
      case 3: {
        console.log("triple click");
        break;
      }
      default: {
        break;
      }
    }
  };

  useEffect(() => {
    let nSELF, nVISITOR;
    let tmp = LIST_USERS?.map((x) => {
      let dTmp = usersJoin.find((y) => y.uid == x.uid);
      if (dTmp != undefined) {
        x.agora = dTmp;
      } else {
        x.agora = null;
      }
      return x;
    });
    if (UidAG(dataValidationUser.data.typeUser) == 1) {
      nSELF = 1;
      nVISITOR = 2;
    } else {
      nSELF = 2;
      nVISITOR = 1;
    }
    let usSELF = tmp.find((x) => x.uid == nSELF);
    let usVISITOR = tmp.find((x) => x.uid == nVISITOR);
    if (usVISITOR?.agora?.uid != undefined) {
      setIsVisit(true);
      // console.log("triger close VC: tahap 0 user visit true");
    }
    if (usVISITOR?.agora?.uid == undefined && isVisit == true) {
      // console.log("triger close VC: tahap 2");
      handleReGetData();
    }
    setUserSELF(usSELF);
    setUserVISITOR(usVISITOR);
  }, [usersJoin]);

  return (
    <div className="bg-black aspect-auto sm:aspect-[9/16]  h-screen shadow-LOR border border-secondary-800">
      <div className="absolute h-full w-full">
        {userCmaMode == 2 && isSelfTracksReady && (
          // <div className="flex gap-1 flex-nowrap " style={{ height: "100%" }}>
          <VideoPlayerPduli
            isPresent={true}
            videoTrack={selfTracks[1]}
            isVideoMute={!isMuteTrackSelf?.video}
            isMicMute={!isMuteTrackSelf?.audio}
            title={userSELF?.label}
            uid={userSELF?.uid}
            isSpeak={checkVoulumeLevel(usersVolume, userSELF?.uid).status}
          />
          // </div>
        )}
        {userCmaMode == 1 && (
          // <div className="flex gap-1 flex-nowrap " style={{ height: "100%" }}>
          <VideoPlayerPduli
            isPresent={userVISITOR?.agora?.uid != null}
            videoTrack={userVISITOR?.agora?.agoraDetail?.videoTrack}
            isVideoMute={!userVISITOR?.agora?.video}
            isMicMute={!userVISITOR?.agora?.audio}
            title={userVISITOR?.label}
            uid={userVISITOR?.uid}
            isSpeak={checkVoulumeLevel(usersVolume, userVISITOR?.uid).status}
          />
          // </div>
        )}
      </div>
      <Draggable bounds="parent">
        <div className="w-40 bg-secondary-800 aspect-[9/16] rounded-md flex items-center justify-center group border-2 border-primary-600 ">
          {userCmaMode == 1 && isSelfTracksReady && (
            // <div className="flex gap-1 flex-nowrap " style={{ height: "100%" }}>
            <VideoPlayerPduli
              isPresent={true}
              videoTrack={selfTracks[1]}
              isVideoMute={!isMuteTrackSelf?.video}
              isMicMute={!isMuteTrackSelf?.audio}
              title={userSELF?.label}
              uid={userSELF?.uid}
              isSpeak={checkVoulumeLevel(usersVolume, userSELF?.uid).status}
            />
            // </div>
          )}
          {userCmaMode == 2 && (
            <VideoPlayerPduli
              isPresent={userVISITOR?.agora?.uid != null}
              videoTrack={userVISITOR?.agora?.agoraDetail?.videoTrack}
              isVideoMute={!userVISITOR?.agora?.video}
              isMicMute={!userVISITOR?.agora?.audio}
              title={userVISITOR?.label}
              uid={userVISITOR?.uid}
              isSpeak={checkVoulumeLevel(usersVolume, userVISITOR?.uid).status}
            />
          )}
          <div
            className="absolute h-full w-full bg-white hidden group-hover:flex flex-col opacity-80  items-center justify-center cursor-move gap-1 "
            onClick={handleClick}
          >
            <div className="flex gap-1 items-center ">
              <ArrowsMove size={16} />
              <p className="text-black "> Pindahkan</p>
              {/* <p className="text-black "> Drag</p> */}
            </div>
            <div className="flex gap-1 items-center absolute bottom-2">
              <BoxArrowDownLeft size={12} />
              <p className="text-black text-xs">
                {/* 2 Clicks to switch view */}
                2x Klik, Tukar Tempat{" "}
              </p>
            </div>
          </div>
          {/* <p className="text-white group-hover:hidden">Video Konsleor</p> */}
        </div>
      </Draggable>

      {isWillBeEnd && (
        <div className="absolute bottom-20 px-4 w-full flex justify-center">
          <div className="w-full transition-all duration-75 ease-in-out shadow-lg ">
            <div
              className={
                "text-white px-6 py-2 border-0 rounded relative  transition-all duration-75   bg-red-500 animate-fadeI"
              }
            >
              <div className="flex items-center">
                <span className="text-xl inline-block mr-3 align-middle">
                  <ExclamationCircle className="h-7 w-7 text-white" />
                </span>

                <span className="inline-block align-middle mr-8 ">
                  <b className="capitalize">Perhatian!</b> Panggilan akan segera
                  berakhir
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {recordingIsAvailable?.agora != null && (
        <div className="absolute top-3 right-3 flex justify-center items-center gap-1 bg-secondary-500 py-1 px-3 rounded-full">
          <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
          <p className="text-white">REC</p>
        </div>
      )}
      <div className="absolute w-[98%] m-1 bottom-1 p-2 bg-secondary-700 rounded-2xl">
        {isSelfTracksReady && selfTracks && isConnect && (
          <KonselorControl
            tracks={selfTracks}
            tracksState={isMuteTrackSelf}
            errorInfo={errorInfo}
            setJoin={(v) => {
              // setJoin(v);
              handleCLoseRoomByServer();
            }}
            setMute={(v) => {
              // console.log("Test pduli agora mute", v);
              setMuteSelfTracks(v?.type, v?.status);
            }}
            handleDurationComplete={() => {
              setJoin(false);
              handleCLoseRoom();
            }}
          />
        )}
      </div>
    </div>
  );
}
